import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { ApiUrl } from "../../../ApiUrl";


const moduleHierarchy = [
  { parent: "dashboard", label: "Dashboard", children: [
    { code: "dashboard.fee_dashboard", label: "Fee Dashboard" },
    { code: "dashboard.attendance", label: "Attendance Dashboard" },
    { code: "dashboard.trustee_dashboard", label: "Trustee Dashboard" },
    { code: "dashboard.principal_dashboard", label: "Principal Dashboard" },
    { code: "dashboard.superadmin_dashboard", label: "Super Admin Dashboard" },
    { code: "dashboard.Register_dashboard", label: "Register Dashboard" },
    { code: "dashboard.accountant_dashboard", label: "Accountant Dashboard" },
    { code: "dashboard.hr_dashboard", label: "HR Dashboard" },
    { code: "dashboard.exam_dashboard", label: "Exam Dashboard" },
    { code: "dashboard.teacher_dashboard", label: "Teacher Dashboard" },
    { code: "dashboard.student_dashboard", label: "Student Dashboard" },
    { code: "dashboard.parent_dashboard", label: "Parent Dashboard" },
    { code: "dashboard.tp_dashboard", label: "Training & Placement Dashboard" },
  ]},
  { parent: "student", label: "Student", children: [
    { code: "student.registration", label: "Registration" },
    { code: "student.attendance", label: "Attendance" },
    { code: "student.assignment", label: "Assignment" },
    { code: "student.promotion", label: "Promotion" },
    { code: "student.class", label: "Student Course" },
    { code: "student.confirm", label: "Student Confirm" },
    { code: "student.certificate", label: "Student Certificate" },
    { code: "student.message", label: "Student Message" },
    { code: "student.club", label: "Student Club" },
    { code: "student.circular", label: "Circulars" },
  ]},
  { parent: "staff", label: "Staff", children: [
    { code: "staff.registration", label: "Registration" },
  ]},
  { parent: "fee", label: "Fee", children: [
    { code: "fee.search", label: "Search" },
    { code: "fee.adhoc", label: "ADHOC Fees" },
    { code: "fee.ledger", label: "Fee Ledger" },
    { code: "fee.student_fee", label: "Student Fee" },
    { code: "fee.structure", label: "Fee Structure" },
    { code: "fee.report", label: "Fee Report" },
  ]},
  { parent: "library", label: "Library", children: [
    { code: "library.library_dashboard", label: "Library Dashboard" },
    { code: "library.dashboard", label: "Book Dashboard" },
    { code: "library.category", label: "Book Category" },
    { code: "library.search", label: "Search" },
    { code: "library.configurations", label: "Book Configurations" },
    { code: "library.movements", label: "Issue/Return" },
    { code: "library.barcode", label: "Book Barcode" },
    { code: "library.title_report", label: "Book Title Report" },
    { code: "library.journal_report", label: "Journal Report" },
    { code: "library.accession_report", label: "Book Accession Report" },
    { code: "library.issue_return_report", label: "Issue/Return Report" },
    { code: "library.damaged_report", label: "Lost/Damaged Report" },
    { code: "library.most_circulated", label: "Most Circulated Book Report" },
  ]},
  { parent: "exam_results", label: "Exam Results", children: [
    { code: "exam_results.result", label: "Result" },
  ]},
  { parent: "transport", label: "Transport", children: [
    { code: "transport.dashboard", label: "Transport Dashboard" },
    { code: "transport.search", label: "Search" },
    { code: "transport.student_fee", label: "Student Transport Fee" },
  ]},
  { parent: "expense", label: "Expense", children: [
    { code: "expense.search", label: "Search Expense" },
    { code: "expense.category", label: "Expense/Income Category" },
    { code: "expense.party_master", label: "Party Master" },
    { code: "expense.ledger", label: "Expense Ledger" },
    { code: "expense.profit_loss", label: "Profit & Loss" },
    { code: "expense.day_book", label: "Day Book" },
  ]},
  { parent: "other_income", label: "Other Income", children: [
    { code: "other_income.search", label: "Search Income" },
  ]},
  { parent: "hostel", label: "Hostel", children: [
    { code: "hostel.dashboard", label: "Hostel Dashboard" },
    { code: "hostel.search", label: "Search" },
    { code: "hostel.student_details", label: "Student Hostel Details" },
    { code: "hostel.student_fee", label: "Student Hostel Fee" },
  ]},
  { parent: "timetable", label: "TimeTable", children: [
    { code: "timetable.class", label: "Class TimeTable" },
    { code: "timetable.teacher", label: "Teacher TimeTable" },
  ]},
  { parent: "lessonplan", label: "Lesson Plan", children: [
    { code: "lessonplan.lesson_plan", label: "Lesson Plan" },
    { code: "lessonplan.teacher", label: "Teacher Lesson Plan" },
    { code: "lessonplan.completion_report", label: "Lesson Plan Completion Report" },
  ]},
  { parent: "mentor", label: "Mentor", children: [
    { code: "mentor.assign", label: "Assign Mentor" },
    { code: "mentor.follow_ups", label: "Follow Ups" },
    { code: "mentor.student_details", label: "Student Details" },
  ]},
  { parent: "academics", label: "Academics", children: [
    { code: "academics.document_upload", label: "Document Upload" },
  ]},
  { parent: "grievance", label: "Grievance", children: [
    { code: "grievance.student", label: "Student Grievances" },
  ]},
  { parent: "visitors", label: "Visitors", children: [
    { code: "visitors.list", label: "Visitors List" },
  ]},
  { parent: "mou", label: "MOU", children: [
    { code: "mou.list", label: "MOU List" },
  ]},
  { parent: "training_placements", label: "Training and Placements", children: [
    { code: "training_placements.training", label: "Training" },
  ]},
  { parent: "inventory", label: "Inventory Management", children: [
    { code: "inventory.category", label: "Inventory Category" },
    { code: "inventory.search", label: "Inventory Search" },
  ]},
  { parent: "role", label: "Role", children: [
    { code: "role.create_admin_user", label: "Create New Role" },
    { code: "role.change_password", label: "Change Password", disabled: true },
  ]},
];


const EditAdminUserModal = ({ show, handleClose, roleData, staffMap, onUpdateSuccess }) => {
  const [roleName, setRoleName] = useState("");
  const [selectedModules, setSelectedModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    if (roleData) {
      setRoleName(roleData.role_name || "");
      const modules = roleData.accessible_modules || [];
      setSelectedModules(modules.includes("role.change_password") ? modules : [...modules, "role.change_password"]);
    }
  }, [roleData]);

  const handleParentToggle = (pm) => {
    const selectable = pm.children.filter((c) => !c.disabled).map((c) => c.code);
    const allSelected = selectable.every((c) => selectedModules.includes(c));
    setSelectedModules((prev) =>
      allSelected ? prev.filter((c) => !selectable.includes(c)) : [...prev, ...selectable.filter((c) => !prev.includes(c))]
    );
    if (errors.modules) setErrors((p) => ({ ...p, modules: "" }));
  };

  const handleChildToggle = (childCode) => {
    const pm = moduleHierarchy.find((p) => p.children.some((c) => c.code === childCode));
    if (pm) {
      const child = pm.children.find((c) => c.code === childCode);
      if (child && child.disabled) return;
    }
    setSelectedModules((prev) => prev.includes(childCode) ? prev.filter((c) => c !== childCode) : [...prev, childCode]);
    if (errors.modules) setErrors((p) => ({ ...p, modules: "" }));
  };

  const isParentFullySelected = (p) => p.children.every((c) => selectedModules.includes(c.code));
  const isParentPartiallySelected = (p) => {
    const selectable = p.children.filter((c) => !c.disabled).map((c) => c.code);
    const count = selectable.filter((c) => selectedModules.includes(c)).length;
    return count > 0 && count < selectable.length;
  };
  const getSelectedCount = (p) => p.children.filter((c) => selectedModules.includes(c.code)).length;

  const handleSelectAll = () => {
    const allSelectable = moduleHierarchy.flatMap((p) => p.children.filter((c) => !c.disabled).map((c) => c.code));
    const disabled = moduleHierarchy.flatMap((p) => p.children.filter((c) => c.disabled).map((c) => c.code));
    const allSelected = allSelectable.every((c) => selectedModules.includes(c));
    setSelectedModules(allSelected ? disabled : [...allSelectable, ...disabled]);
  };

  const getTotalCount = () => moduleHierarchy.reduce((s, p) => s + p.children.length, 0);

  const handleUpdate = async () => {
    const newErrors = {};
    if (!roleName.trim()) newErrors.roleName = "Role Name is required";
    if (selectedModules.length === 0) newErrors.modules = "Please select at least one module";
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    try {
      const res = await fetch(`${ApiUrl.apiurl}AdminUser/Update/${roleData.id}/`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({ role_name: roleName, accessible_modules: selectedModules }),
      });
      const result = await res.json();
      if (res.ok || result.message?.toLowerCase().includes("success")) {
        setSuccessMessage("Admin user updated successfully!");
        setTimeout(() => onUpdateSuccess(), 1500);
      } else {
        setErrorMessage(result.message || "Failed to update");
      }
    } catch (err) {
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" backdrop="static">
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>Edit Admin User</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        <div className="row">
          <div className="col-md-5">
            <div className="card mb-3">
              <div className="card-header bg-light"><h6 className="mb-0">User Information</h6></div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label fw-bold">Username <span className="text-muted small">(Cannot be changed)</span></label>
                  <input type="text" className="form-control bg-light" value={roleData.user_name} disabled />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Role Name <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${errors.roleName ? "is-invalid" : ""}`}
                    value={roleName}
                    onChange={(e) => { setRoleName(e.target.value); if (errors.roleName) setErrors((p) => ({ ...p, roleName: "" })); }}
                    placeholder="Enter role name"
                  />
                  {errors.roleName && <div className="invalid-feedback">{errors.roleName}</div>}
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Non Teaching Staff <span className="text-muted small">(Cannot be changed)</span></label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={roleData.reference_id && roleData.reference_id !== 0 ? staffMap[roleData.reference_id] || "N/A" : "N/A"}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-7">
            <div className="card">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h6 className="mb-0">Accessible Modules <span className="text-danger">*</span></h6>
                <div className="d-flex align-items-center gap-2">
                  <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleSelectAll}>
                    {moduleHierarchy.flatMap((p) => p.children.filter((c) => !c.disabled).map((c) => c.code)).every((c) => selectedModules.includes(c)) ? "Deselect All" : "Select All"}
                  </button>
                  <span className="badge bg-primary">{selectedModules.length}/{getTotalCount()}</span>
                </div>
              </div>
              <div className="card-body" style={{ maxHeight: "420px", overflowY: "auto" }}>
                {errors.modules && <div className="alert alert-danger py-2">{errors.modules}</div>}
                {moduleHierarchy.map((pm) => (
                  <div key={pm.parent} className="mb-3">
                    <div className="d-flex align-items-center mb-1">
                      <div className="form-check me-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`edit-parent-${pm.parent}`}
                          checked={isParentFullySelected(pm)}
                          ref={(el) => { if (el) el.indeterminate = isParentPartiallySelected(pm); }}
                          onChange={() => handleParentToggle(pm)}
                        />
                        <label className="form-check-label fw-bold" htmlFor={`edit-parent-${pm.parent}`}>{pm.label}</label>
                      </div>
                      <span className="badge bg-secondary ms-1" style={{ fontSize: "10px" }}>{getSelectedCount(pm)}/{pm.children.length}</span>
                    </div>
                    <div className="row ms-4">
                      {pm.children.map((child) => (
                        <div key={child.code} className="col-6 mb-1">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`edit-child-${child.code}`}
                              checked={selectedModules.includes(child.code)}
                              onChange={() => handleChildToggle(child.code)}
                              disabled={child.disabled || false}
                            />
                            <label className="form-check-label small" htmlFor={`edit-child-${child.code}`}>
                              {child.label}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={handleUpdate} disabled={loading}>
          {loading ? "Updating..." : "Update"}
        </button>
        <button className="btn btn-secondary" onClick={handleClose} disabled={loading}>Cancel</button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAdminUserModal;
